const translateAlt = {
  chinaFlag: 'China Flag',
  malaysiaFlag: 'Malaysia Flag',
  britainFlag: 'Great Britain Flag',
};

export default translateAlt;
